<template>
  <div class="permission-box box">
    <div class="row">
      <div class="col-12">
        <label class="title">{{
          $t('preRegistration.step4.front.auth.title')
        }}</label>
      </div>
    </div>
    <ul class="row row-gap-2">
      <li class="flex-align-center">
        <b>Cam</b>
        <span :class="[checkedCamera ? 'allow' : '']">{{
          checkedCamera
            ? $t('preRegistration.step4.front.auth.grant')
            : $t('preRegistration.step4.front.auth.deny')
        }}</span>
      </li>
      <li class="flex-align-center">
        <b>Mic</b>
        <span :class="[checkedMicrophone ? 'allow' : '']">{{
          checkedMicrophone
            ? $t('preRegistration.step4.front.auth.grant')
            : $t('preRegistration.step4.front.auth.deny')
        }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
  import {getMediaPermissionsStatus} from '@/js/utils/camera';
  import {PERMISSION_STATE} from '@/js/common/constants';
  export default {
    name: 'Permission',
    data() {
      return {
        cameraPermission: null,
        microphonePermission: null,
        cameraState: PERMISSION_STATE.PROMPT,
        microphoneState: PERMISSION_STATE.PROMPT,
      };
    },

    mounted() {
      this.handlePermission();
    },

    methods: {
      async handlePermission() {
        const {camera, microphone} = await getMediaPermissionsStatus();

        if (!camera || !microphone) return;

        this.cameraPermission = camera;
        this.microphonePermission = microphone;

        this.cameraState = camera.state;
        this.microphoneState = microphone.state;

        this.cameraPermission.onchange = () => {
          this.cameraState = camera.state;
        };

        this.microphonePermission.onchange = () => {
          this.microphoneState = microphone.state;
        };
      },

      cleanupPermissions() {
        if (this.cameraPermission) {
          this.cameraPermission.onchange = null;
        }
        if (this.microphonePermission) {
          this.microphonePermission.onchange = null;
        }
      },
    },

    beforeDestroy() {
      this.cleanupPermissions();
    },

    computed: {
      checkedCamera() {
        return this.cameraState === PERMISSION_STATE.GRANTED;
      },

      checkedMicrophone() {
        return this.microphoneState === PERMISSION_STATE.GRANTED;
      },
    },

    watch: {
      camera(newValue) {
        if (newValue !== PERMISSION_STATE.DENIED) return;

        this.$emit('handleDenied');
      },

      microphone(newValue) {
        if (newValue !== PERMISSION_STATE.DENIED) return;

        this.$emit('handleDenied');
      },
    },
  };
</script>
